//Popover more options used in this component and MyCourseCard
export const CardMoreOptions = [
    {
        text: "Reset Progress",
        icon: "icnReset",
        width: 15,
        height: 13
    }
];